import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Shared';
export function Guarantee() {
  return <Section className="max-w-3xl" data-id="element-95" data-mp="3gg11ma61ua0t">
      <article className="rounded-3xl border border-brand-green/25 bg-brand-cream p-8 text-center shadow-[0_12px_30px_rgba(23,59,43,.09)] md:p-12" data-id="element-96" data-mp="3gh3qkcjta2e3">
        <div className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-full bg-brand-surfaceLight" data-id="element-97" data-mp="36qhgexuv642s">
          <ShieldCheckIcon className="h-9 w-9 text-brand-green" data-id="element-98" data-mp="3ugbs3c3g5mlg" />
        </div>
        <h2 className="font-display text-3xl font-bold text-brand-dark md:text-4xl" data-id="element-99" data-mp="38za4uuqp54h">
          Garantía 7 días — sin preguntas
        </h2>
        <p className="mt-5 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-100" data-mp="3le2jirrqo3ap">
          Abrís el Código Hepático. Revisás el manual. Usás la guía clínica en
          tu próxima sesión. Entregás la hoja de ruta a tu paciente. Observás la
          diferencia.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-101" data-mp="2ezbeqczhvybe">
          Si en 7 días no es lo que esperabas: devolución del 100% sin
          formularios, sin drama.
        </p>
        <p className="mt-6 text-sm font-bold text-brand-green" data-id="element-102" data-mp="3gbikcl8ypbyn">
          Tasa de devoluciones: menos del 1%.
        </p>
      </article>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-brand-yellow/25 bg-brand-deep py-12 text-brand-cream" data-id="element-103" data-mp="3q7lm3pzwj8l2">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-104" data-mp="81yvkel2tq1v">
        <h2 className="font-display text-3xl font-bold text-brand-yellow" data-id="element-105" data-mp="34723g4s9vvk">
          LUMEN AKASHA™
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-brand-cream/75" data-id="element-106" data-mp="ht3a5d6ub8w6">
          El sistema de salud funcional y holística N°1 para terapeutas en
          Argentina.
        </p>
        <p className="mx-auto mt-2 max-w-3xl text-sm leading-relaxed text-brand-cream/75" data-id="element-107" data-mp="qsqd43f7wmrc">
          Porque acompañar la salud de tus pacientes no debería hacerse sin
          información, sin herramientas y sin un protocolo claro que potencie
          cada sesión.
        </p>
        <nav aria-label="Contacto" className="mt-9 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-108" data-mp="yty1bvsfwx5p">
          <a className="transition-colors hover:text-brand-yellow focus:outline-none focus:ring-2 focus:ring-brand-yellow" href="mailto:soportelumenakasha@gmail.com" data-id="element-109" data-mp="13rzigb6b2mej">
            📩soportelumenakasha@gmail.com
          </a>
          <a className="transition-colors hover:text-brand-yellow focus:outline-none focus:ring-2 focus:ring-brand-yellow" href="https://instagram.com/lumen.akasha" data-id="element-110" data-mp="1hjw8m9oeym8a">
            📱@lumen.akasha
          </a>
          <a className="transition-colors hover:text-brand-yellow focus:outline-none focus:ring-2 focus:ring-brand-yellow" href="https://wa.me/5491153399780" data-id="element-111" data-mp="1ri3k4czxoc2w">
            📲WhatsApp: 11 5339-9780
          </a>
          <a className="transition-colors hover:text-brand-yellow focus:outline-none focus:ring-2 focus:ring-brand-yellow" href="https://www.lumenakasha.com" data-id="element-112" data-mp="2afnbh94hzvyp">
            🌐www.lumenakasha.com
          </a>
        </nav>
        <div className="mt-10 space-y-2 text-xs text-brand-cream/50" data-id="element-113" data-mp="21n1x057wgbfo">
          <p data-id="element-114" data-mp="1wp0bldn04011">
            © Lumen Akasha™ 2024 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-115" data-mp="2pbuw2ajtizei">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
        <p className="mt-8 font-serif text-sm italic text-brand-yellow/85" data-id="element-116" data-mp="2kc8iu13zpj5p">
          “No estás cambiando tu forma de trabajar. Estás potenciando todo lo
          que ya sabés con las herramientas que faltaban.”
        </p>
      </div>
    </footer>;
}